import { CheckIcon, GKButton, GKModal, GKTextField, Grid2 } from "components";
import { Controller, useForm, useFormContext } from "react-hook-form";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";

interface Props {
  favoriteRefetch: any;
  otherData: any;
}

interface FormValues {
  name: string;
  broker: string;
  file_type: string;
  version: string | number;
}

const AddFavoriteTemplate = ({
  open,
  setOpen,
  otherData,
  favoriteRefetch,
}: Props & GKModalProps) => {
  const importForm = useFormContext();

  const form = useForm({
    defaultValues: {
      name: "",
      broker: otherData?.fileBrokerType,
      file_type: otherData?.fileType,
      version: otherData?.fileVersion,
    },
  });

  const onSubmit = async (values: FormValues) => {
    await axiosInstance
      .post(`/transaction_upload/fav_upload/`, {
        title: values.name,
        upload_file: "Stock",
        broker: otherData?.fileBrokerType,
        file_type: otherData?.fileType,
        version: otherData?.fileVersion,
      })
      .then(() => {
        importForm.setValue("templatesTabs", 1);
        toast.success(`${values.name} Successfully added to favorites`);
        favoriteRefetch();
        setOpen(false);
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong, please try again.",
        );
      });
  };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Import Template "
      width={"400px"}
      footer={
        <GKButton
          fullWidth
          form="add-favorite-form"
          type="submit"
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Save Template Name
        </GKButton>
      }
    >
      <form id="add-favorite-form" onSubmit={form.handleSubmit(onSubmit)}>
        <Grid2 container>
          <Grid2 size={12}>
            <Controller
              name="name"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Template Title"
                />
              )}
            />
          </Grid2>
        </Grid2>
      </form>
    </GKModal>
  );
};

export default AddFavoriteTemplate;
